import React from 'react'
import PaymentListing from '../components/PaymentListing'

const PaymentList = () => {
  return (
    <div><PaymentListing /></div>
  )
}

export default PaymentList